const STORAGE_KEY = "ekliptik:admin-theme"
const LIGHT_THEME = "light"
const DARK_THEME = "dark"

function systemTheme() {
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? DARK_THEME : LIGHT_THEME
}

function storedTheme() {
  try {
    const theme = localStorage.getItem(STORAGE_KEY)
    return theme === DARK_THEME || theme === LIGHT_THEME ? theme : null
  } catch (_error) {
    return null
  }
}

function currentTheme() {
  return document.documentElement.getAttribute("data-bs-theme") || storedTheme() || systemTheme()
}

function applyTheme(theme) {
  document.documentElement.setAttribute("data-bs-theme", theme)
  document.documentElement.style.colorScheme = theme
}

function persistTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme)
  } catch (_error) {
    // Ignore storage errors and keep the theme only for the current page load.
  }
}

function syncThemeToggles() {
  const theme = currentTheme()
  const isDark = theme === DARK_THEME

  document.querySelectorAll("[data-admin-theme-toggle]").forEach((button) => {
    const icon = button.querySelector("[data-admin-theme-icon]")
    const label = button.querySelector("[data-admin-theme-label]")
    const nextThemeLabel = isDark ? button.dataset.themeSwitchToLight : button.dataset.themeSwitchToDark
    const currentThemeLabel = isDark ? button.dataset.themeDarkLabel : button.dataset.themeLightLabel

    button.setAttribute("aria-pressed", String(isDark))
    button.setAttribute("aria-label", nextThemeLabel)
    button.setAttribute("title", nextThemeLabel)

    if (label) label.textContent = currentThemeLabel

    if (icon) {
      icon.classList.toggle("bi-moon-stars", !isDark)
      icon.classList.toggle("bi-sun", isDark)
    }
  })
}

function toggleTheme() {
  const nextTheme = currentTheme() === DARK_THEME ? LIGHT_THEME : DARK_THEME

  applyTheme(nextTheme)
  persistTheme(nextTheme)
  syncThemeToggles()
}

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-admin-theme-toggle]")
  if (!button) return

  toggleTheme()
})

syncThemeToggles()
document.addEventListener("turbo:load", syncThemeToggles)
